<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import { dsrwgl_query, dsrw_update } from '@/api/dsrw';
import addTask from './addTask/index.vue'
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: 'ywlxgz',
    components: {addTask},
    data: function() {
        return {
            searchdiag: false,
            filterSearchlist: [],
            searchlist: getdata().searchlist,
            searchdata: getdata().searchdata,
            pagination: getdata().pagination,
            headData: getdata().headData,
            tableData: [],
            tablekey: 0,
            overlength: 0,
            rwzt: comMapping.$taskStatus,
            taskDialog: false,
            taskDialogTitle: "",
            wikiType: "",
            diaFormData: {}
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        formatRwzt(code) {
           return this.rwzt.filter(x => code===x.value).map(x => x.label)[0];
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.taskInfoQuery();
        },
        geOoverLength(e) {
            this.overlength = e;
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.taskInfoQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.taskInfoQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.taskInfoQuery();
            this.ywgzpg = false;
        },
        closediag() {
            this.ztdiag = false;
            this.taskInfoQuery();
        },
        //初始化
        init() {
            this.taskInfoQuery();
        },
        taskInfoQuery() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            dsrwgl_query(params).then(res => {
                if (res.data.code !== 1) {
                    this.$message.error(res.data.msg);
                } else {
                    this.pagination.total = res.data.data.total;
                    this.tableData = res.data.data.records;
                }
            })
        },
        addTask() {
            this.taskDialog = true;
            this.taskDialogTitle = "添加任务";
            this.wikiType = "0";
            this.diaFormData = {}
        },
        editTask(row) {
            this.taskDialog = true;
            this.taskDialogTitle = "修改任务";
            this.wikiType = "1";
            this.diaFormData = this.tableData.filter(x => x.id === row.id)[0]
        },
        updateStatus(row, status) {
            let params = row;
            params.jobStatus = status;
            // 修改
            dsrw_update(params).then(res => {
                if (res.data.code === 1) {
                    this.$message.success('保存成功！');
                    this.closediag();
                } else {
                    this.$message.error(res.data.msg + ":" +res.data.data);
                }
            })
        },
        addTaskclosediag() {
            this.taskDialog = false;
            this.taskInfoQuery();
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
